import React, { useState } from "react";
import icochevrondown from "../assets/scenariobar/flecha-scenario-bar-down.svg";
import icochevronup from "../assets/scenariobar/flecha-scenario-bar-up.svg";
import icoLockClosed from "../assets/candado-cerrado.svg";
import candadoOpenOrange from "../assets/scenariobar/candado-open-orange.svg";
import candadoOpenViolet from "../assets/scenariobar/candado-open-violet.svg";
import candadoOpenBlue from "../assets/scenariobar/candado-open-blue.svg";
import candadoOpenGreen from "../assets/scenariobar/candado-open-green.svg";

import "./ScenarioBar.css";

const STEPS = [
	{ id: 2, accent: "s2", label: "Llegada y control de la situación" },
	{ id: 3, accent: "s3", label: "Obtención de información y verificación de hechos" },
	{ id: 4, accent: "s4", label: "Toma de decisiones operativas" },
	{ id: 5, accent: "s5", label: "Resolución y cierre de la intervención" },
];

function getIcon(idx, activeScenario) {
	if (idx <= activeScenario) {
		switch (idx) {
			case 2:
				return candadoOpenOrange;
			case 3:
				return candadoOpenViolet;
			case 4:
				return candadoOpenBlue;
			case 5:
				return candadoOpenGreen;
			default:
				return icoLockClosed;
		}
	}
	return icoLockClosed;
}

function cardPhase(stepId, activeScenario) {
	if (stepId < activeScenario) return "past";
	if (stepId === activeScenario) return "current";
	return "future";
}

function ScenarioBar({ activeScenario, expanded, onScenarioClick }) {
	const [scenarioBarOpen, setScenarioBarOpen] = useState(expanded || false);

	function handleToggle(e) {
		e.stopPropagation();
		setScenarioBarOpen((o) => !o);
	}

	const canNavigateTo = (idx) =>
		idx === activeScenario && typeof onScenarioClick === "function";

	const handleScenarioBoxClick = (idx) => {
		if (canNavigateTo(idx)) onScenarioClick(idx);
	};

	return (
		<div
			className={`sc-bar ${scenarioBarOpen ? "sc-bar--expanded" : "sc-bar--collapsed"}`}
		>
			<button
				type="button"
				className="sc-bar__handle"
				onClick={handleToggle}
				aria-expanded={scenarioBarOpen}
				aria-label={
					scenarioBarOpen ? "Ocultar barra de escenarios" : "Mostrar barra de escenarios"
				}
			>
				<img
					src={scenarioBarOpen ? icochevrondown : icochevronup}
					alt=""
					className="sc-bar__handleImg"
					aria-hidden
				/>
			</button>

			{!scenarioBarOpen ? (
				<span className="sc-bar__peekLabel">Escenarios</span>
			) : null}

			<div className="sc-bar__inner">
				{STEPS.map(({ id, accent, label }) => {
					const phase = cardPhase(id, activeScenario);
					const navigable = canNavigateTo(id);
					const phaseClass =
						phase === "past"
							? "sc-bar__card--past"
							: phase === "current"
								? "sc-bar__card--current"
								: "sc-bar__card--future";

					return (
						<div
							key={id}
							className={`sc-bar__card sc-bar__card--${accent} ${phaseClass}${navigable ? " sc-bar__card--clickable" : ""}`}
							role={navigable ? "button" : undefined}
							tabIndex={navigable ? 0 : undefined}
							aria-current={phase === "current" ? "step" : undefined}
							onClick={() => handleScenarioBoxClick(id)}
							onKeyDown={(e) => {
								if (!navigable) return;
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									handleScenarioBoxClick(id);
								}
							}}
						>
							<img
								src={getIcon(id, activeScenario)}
								alt=""
								className="sc-bar__lock"
							/>
							<span className="sc-bar__label">{label}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default ScenarioBar;
